// check to see if the browsers supports webp
(function(global, factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], function($) {
            return factory($, global, global.document);
        });
    } else if (typeof exports === "object" && exports) {
        module.exports = factory(require('jquery'), global, global.document);
    } else {
        factory(jQuery, global, global.document);
    }
})(typeof window !== 'undefined' ? window : this, function($, window, document, undefined) {
    'use strict';
    const settings = {};
    const $window = $(window);
    const $document = $(document);

    function webpSupport(callback) {
        // If the browser doesn't has the method createImageBitmap, you can't display webp format
        if (!window.createImageBitmap) {
            callback(false);
            return;
        }
        // Base64 representation of a white point image
        var webpdata = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoCAAEAAQAcJaQAA3AA/v3AgAA=';
        // Retrieve the Image in Blob Format
        fetch(webpdata).then(function(response){
            return response.blob();
        }).then(function(blob) {
            // If the createImageBitmap method succeeds, return true, otherwise false
            createImageBitmap(blob).then(function() {
                callback(true);
            }, function(){
                callback(false);
            });
        });
    }

    const lazyload = class {

        constructor(element, options) {
            this.element = element;
            this.options = $.extend({}, settings, options);
            this.settings = settings;
            this.init();
        }
        init() {
            // webpSupport(function(isSupported) {
            //     if (isSupported) {
            //         console.log("Supported");
            //     } else {
            //         console.log("Not supported");
            //     }
            // });
        }
    }

    $.fn.lazyload = function(options) {
        if (!$.data(this, 'lazyload')) {
            return $.data(this, 'lazyload', new lazyload(this, options));
        }
    };
});
